/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rscu_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a coding sequence above to compute RSCU.`)
};

const es_rscu_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una secuencia codificante arriba para calcular el RSCU.`)
};

const de_rscu_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie oben eine Kodierungssequenz ein, um RSCU zu berechnen.`)
};

const nl_rscu_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak hierboven een coderende sequentie om RSCU te berekenen.`)
};

const fr_rscu_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une séquence codante ci-dessus pour calculer le RSCU.`)
};

const it_rscu_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla una sequenza codificante sopra per calcolare l'RSCU.`)
};

const pt_br2_rscu_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência codificante acima para calcular o RSCU.`)
};

const pt_rscu_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência codificante acima para calcular o RSCU.`)
};

const ja_rscu_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上にコード配列を貼り付けるとRSCUが計算されます。`)
};

const zh_rscu_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在上方粘贴编码序列以计算 RSCU。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rscu_hint_empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rscu_hint_empty(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rscu_hint_empty", locale)
	if (locale === "en") return en_rscu_hint_empty(inputs)
	if (locale === "es") return es_rscu_hint_empty(inputs)
	if (locale === "de") return de_rscu_hint_empty(inputs)
	if (locale === "nl") return nl_rscu_hint_empty(inputs)
	if (locale === "fr") return fr_rscu_hint_empty(inputs)
	if (locale === "it") return it_rscu_hint_empty(inputs)
	if (locale === "pt-BR") return pt_br2_rscu_hint_empty(inputs)
	if (locale === "pt") return pt_rscu_hint_empty(inputs)
	if (locale === "ja") return ja_rscu_hint_empty(inputs)
	return zh_rscu_hint_empty(inputs)
};